module.exports = __webpack_public_path__ + "static/media/standard_white.9c871e67.svg";